import { execSync } from 'child_process'
import path from 'path'
import fs from 'fs'

const corePrismaSchema = path.resolve(
    __dirname, '../../prisma/schema.prisma'
)

const migrationDir = path.resolve(
    process.cwd(), 'prisma/migrations'
)

// generate datetime string e.g. 20240101_120000
const now = new Date()
const datetime = now.getFullYear().toString() +
    String(now.getMonth() + 1).padStart(2, '0') +
    String(now.getDate()).padStart(2, '0') +
    '_' +
    String(now.getHours()).padStart(2, '0') +
    String(now.getMinutes()).padStart(2, '0') +
    String(now.getSeconds()).padStart(2, '0')

const fileName = `migration_core-${datetime}.sql`
const migrationFile = path.resolve(migrationDir, fileName)

// 1. create migrations folder
fs.mkdirSync(migrationDir, { recursive: true })

// 2. generate SQL from core schema — no DB needed
execSync(
    `npx prisma migrate diff --from-empty --to-schema-datamodel "${corePrismaSchema}" --script > "${migrationFile}"`,
    {
        stdio: 'inherit',
        cwd: process.cwd(),
        env: {
            ...process.env,
            DATABASE_URL: 'postgresql://dummy:dummy@localhost:5432/dummy'
        }
    }
)

console.log(`✅ Core migration SQL generated at:`)
console.log(`   prisma/migrations/${fileName}`)
console.log('')
console.log('👉 Next steps:')
console.log('   1. Run the SQL against your database')
console.log('   2. Add your own tables')
console.log('   3. Run: npx prisma db pull')
console.log('   4. Run: npx prisma generate')